// @flow
import React, { PureComponent } from 'react'
import { VerticalCol, VerticalRow } from '../../utils/Grid'
import WidgetContainer from '../../containers/WidgetContainer'
import HousingBox from '../../boxes/HousingBox'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import type { HousingWidgetProps } from '../Types'

export default class Housing extends PureComponent<HousingWidgetProps> {
  render () {
    const {
      props: {
        activeDynamicLayout,
        isOpening,
        isOpen,
        handleToggleContent,
        widget,
        widget: {
          boxes,
          imageSize = '4_3',
          utmMedium
        }
      }
    } = this

    if (!boxes.length) {
      return null
    }

    return (
      <WidgetContainer
        widget={widget}
        isOpening={isOpening}
        activeDynamicLayout={activeDynamicLayout}
        isOpen={isOpen}
        handleToggleContent={handleToggleContent}>
        <VerticalRow>
          {
            boxes.map(box => {
              const {
                annotation,
                guid,
                images,
                link,
                price,
                source,
                title
              } = box

              const image = images[imageSize]

              const utmLink = utmLinkGenerator.createLink(link, {
                utmMedium,
                utmTerm: `position-${boxes.indexOf(box)}`,
                utmCampaign: source
              })

              return (
                <VerticalCol key={guid}>
                  <HousingBox
                    annotation={annotation}
                    image={image}
                    imageClass={`image-${imageSize}`}
                    link={utmLink}
                    price={price}
                    title={title}
                  />
                </VerticalCol>
              )
            })
          }
        </VerticalRow>
      </WidgetContainer>
    )
  }
}
